(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-faq-toggle]');
    if (!toggle) return;
    
    var item = toggle.closest('.faq-item');
    if (!item) return;

    var isOpen = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.faq-tabs').forEach(function(tabsEl) {
      var sectionEl = tabsEl.closest('[data-wetheme-section-type]');
      if (!sectionEl) return;

      var filterTrack = tabsEl.querySelector('[data-filter-track]');
      var leftArrow = tabsEl.querySelector('[data-filter-scroll="left"]');
      var rightArrow = tabsEl.querySelector('[data-filter-scroll="right"]');
      var filterBtns = tabsEl.querySelectorAll('[data-faq-tab]');
      var faqGroups = sectionEl.querySelectorAll('[data-faq-group-id]');

      // ---- Tab click: anchor scroll only ----
      filterBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          filterBtns.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var anchorId = btn.getAttribute('data-filter');
          if (!anchorId) return;

          var target = sectionEl.querySelector('#faq-' + anchorId);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // ---- Scroll arrows ----
      if (filterTrack && leftArrow && rightArrow) {
        var scrollAmount = 200;

        leftArrow.addEventListener('click', function() {
          filterTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
        rightArrow.addEventListener('click', function() {
          filterTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        function updateArrows() {
          leftArrow.style.opacity = filterTrack.scrollLeft > 0 ? '1' : '0.3';
          rightArrow.style.opacity = filterTrack.scrollLeft + filterTrack.clientWidth < filterTrack.scrollWidth - 2 ? '1' : '0.3';
        }

        filterTrack.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      // ---- Handle URL hash on page load ----
      var hash = window.location.hash;
      if (hash && hash.startsWith('#faq-')) {
        var filterValue = hash.replace('#faq-', '');
        var matchingBtn = tabsEl.querySelector('[data-faq-tab][data-filter="' + filterValue + '"]');
        if (matchingBtn) {
          setTimeout(function() { matchingBtn.click(); }, 300);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
